import AttractionCarousel from "./AttractionCarousel.js";
import { AttractionsCard } from "./AttractionsCard.js";
import image1 from "./images/banners/shandon.png";
import image2 from "./images/banners/ucc.png";
import image3 from "./images/banners/mtu.png";
import image4 from "./images/banners/ucc2.png";
import image5 from "./images/banners/aula.png";

export default function AttractionsCarousel(props) {
  const attractions = props.prop;
  console.log(attractions);

  return (
    <AttractionCarousel>
      {attractions.map(function (data) {
        return <AttractionsCard props={data} />;
      })}
    </AttractionCarousel>
  );
}
